module.exports = __webpack_public_path__ + "img/banner-working.7c36e203.png";